const decodePolyline = (encoded) => {
    if (!encoded || typeof encoded !== 'string') {
        throw new Error("Geçerli bir kodlanmış string verilmedi.");
    }

    const points = [];
    const factor = 1e5;
    let index = 0, len = encoded.length;
    let lat = 0, lng = 0;

    while (index < len) {
        let byte, shift = 0, result = 0;

        do {
            byte = encoded.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        const dlat = (result & 1 ? ~(result >> 1) : result >> 1);
        lat += dlat;

        shift = 0;
        result = 0;

        do {
            byte = encoded.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        const dlng = (result & 1 ? ~(result >> 1) : result >> 1);
        lng += dlng;

        points.push({ lat: lat / factor, lng: lng / factor });
    }

    return points;
}

export default decodePolyline